import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { adminApi } from "@/lib/api";
import { DailyChart, UsageBar, usd } from "@/components/admin/ApifyUsageCard";

const BudgetForm = ({ value, onSaved }) => {
  const [b, setB] = useState(value || "");
  useEffect(() => setB(value || ""), [value]);
  const save = () => adminApi.setCostSettings({ perplexity_budget_usd: Number(b) || 0 })
    .then(() => { toast.success("Budget Perplexity salvato"); onSaved(); })
    .catch(() => toast.error("Budget non valido"));
  return (
    <div className="flex items-center gap-2 mt-3">
      <span className="text-[11px] text-[#5b6168]">Budget mensile $</span>
      <Input data-testid="pplx-budget-input" type="number" min="0" step="1" value={b} onChange={(e) => setB(e.target.value)}
        className="h-8 w-24 bg-[#f4f6f7] border-[#d5dbde] rounded-sm font-mono text-xs" />
      <button data-testid="pplx-budget-save-btn" onClick={save}
        className="h-8 px-3 text-[11px] border border-[#2B3036] hover:bg-[#2B3036] hover:text-white transition-colors rounded-sm">Salva</button>
      <span className="text-[10px] text-[#6b7280]">avviso 70% · blocco 90%</span>
    </div>
  );
};

export const PerplexityUsageCard = ({ configured }) => {
  const [u, setU] = useState(null);
  const load = () => adminApi.perplexityUsage().then(setU).catch(() => toast.error("Errore lettura consumo Perplexity"));
  useEffect(() => { if (configured) load(); }, [configured]);
  if (!configured) return null;

  return (
    <div data-testid="pplx-usage-card" className="mt-3 p-4 bg-white border border-[#d5dbde] rounded-sm">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-wider">Consumo Perplexity (mese)</span>
        <div className="flex items-center gap-2">
          {u?.blocked && (
            <span data-testid="pplx-usage-blocked-badge" className="flex items-center gap-1 text-[10px] font-mono text-white bg-[#E3242B] px-2 py-0.5 rounded-full">
              <AlertTriangle size={11} /> RICERCA REFERENTI BLOCCATA
            </span>
          )}
          <button data-testid="pplx-usage-refresh-btn" onClick={load} className="text-[#5b6168] hover:text-[#2B3036] transition-colors">
            <RefreshCw size={14} />
          </button>
        </div>
      </div>
      {!u && <p className="text-xs text-[#6b7280] font-mono">Carico…</p>}
      {u && (
        <>
          {u.limit_usd ? <UsageBar u={u} testid="pplx-usage" /> : (
            <p data-testid="pplx-usage-used" className="text-xs font-mono">Spesi {usd(u.used_usd)} · nessun budget impostato</p>
          )}
          <div className="grid md:grid-cols-2 gap-4 mt-4">
            <div className="text-[11px] font-mono space-y-1">
              <div className="flex justify-between border-b border-[#e5e9eb] pb-1"><span>Ricerche referenti</span><span data-testid="pplx-usage-searches">{u.searches}</span></div>
              <div className="flex justify-between border-b border-[#e5e9eb] pb-1"><span>Costo medio</span><span>{usd(u.searches ? u.used_usd / u.searches : 0)}</span></div>
              <div className="flex justify-between border-b border-[#e5e9eb] pb-1"><span>Ciclo</span><span>{u.cycle_start} → {u.cycle_end}</span></div>
            </div>
            <DailyChart daily={u.daily} testid="pplx-usage-daily-chart" />
          </div>
          <BudgetForm value={u.limit_usd} onSaved={load} />
        </>
      )}
    </div>
  );
};
